import axios from 'axios'
import pageKeys from '../common/pagekeys'

//FOR REFACTOR - create separate files/controller for deminimis, fringe and other benefits

export default {
    async getBenefitTypes() {
        try{            
            const response = await axios.get(`Benefits/types`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api getBenefitTypes error')
            throw error
        }
    },

    //DEMINIMIS
    async getDeminimisHistory(userId) {
        try{            
            const response = await axios.get(`Benefits/deminimis/history/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api getDeminimisHistory error')
            throw error
        }
    },
    async addDeminimisAllocation(data) {
        try{            
            const response = await axios.post(`Benefits/deminimis/add`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api addDeminimisAllocation error')
            throw error
        }
    },
    async updateDeminimisAllocation(data) {
        try{            
            const response = await axios.post(`Benefits/deminimis/update`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api updateDeminimisAllocation error')
            throw error
        }
    },
    async deleteDeminimisAllocation(deminimisAllocationId) {
        try{   
            const response = await axios.post(`Benefits/deminimis/delete/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api deleteDeminimisAllocation error')
            throw error
        }
    },
    async undoDeleteDeminimisAllocation(deminimisAllocationId) {
        try{            
            const response = await axios.post(`Benefits/deminimis/undo_delete/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api undoDeleteDeminimisAllocation error')
            throw error
        }
    },
    async rejectDeleteDeminimisAllocation(deminimisAllocationId) {
        try{            
            const response = await axios.post(`Benefits/deminimis/reject_delete/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api rejectDeleteDeminimisAllocation error')
            throw error
        }
    },
    async approveDeleteDeminimisAllocation(deminimisAllocationId) {
        try{            
            const response = await axios.post(`Benefits/deminimis/approve_delete/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api approveDeleteDeminimisAllocation error')
            throw error
        }
    },
    async forReviewDeminimis(deminimisAllocationId) {
        try{            
            const response = await axios.post(`Benefits/deminimis/forReview/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api forReviewDeminimis error')
            throw error
        }
    },
    async approveDeminimis(deminimisAllocationId) {
        try{            
            const response = await axios.post(`Benefits/deminimis/approve/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api approveDeminimis error')
            throw error
        }
    },
    async rejectDeminimis(deminimisAllocationId) {
        try{            
            const response = await axios.post(`Benefits/deminimis/reject/${deminimisAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api rejectDeminimis error')
            throw error
        }
    },

    //OTHER BENEFITS
    async getOtherBenefitsHistory(userId) {
        try{            
            const response = await axios.get(`Benefits/other/history/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api getOtherBenefitsHistory error')
            throw error
        }
    },
    async addOtherBenefits(data) {
        try{            
            const response = await axios.post(`Benefits/other/add`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api addOtherBenefits error')
            throw error
        }
    },
    async updateOtherBenefits(data) {
        try{            
            const response = await axios.post(`Benefits/other/update`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api updateOtherBenefits error')
            throw error
        }
    },
    async deleteOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/delete/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api deleteOtherBenefits error')
            throw error
        }
    },
    async undoDeleteOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/undo_delete/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api undoDeleteOtherBenefits error')
            throw error
        }
    },
    async rejectDeleteOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/reject_delete/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api rejectDeleteOtherBenefits error')
            throw error
        }
    },
    async approveDeleteOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/approve_delete/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api approveDeleteOtherBenefits error')
            throw error
        }
    },
    async forReviewOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/forReview/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api forReviewOtherBenefits error')
            throw error
        }
    },
    async approveOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/approve/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api approveOtherBenefits error')
            throw error
        }
    },
    async rejectOtherBenefits(otherBenefitsAllocationId) {
        try{            
            const response = await axios.post(`Benefits/other/reject/${otherBenefitsAllocationId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api rejectOtherBenefits error')
            throw error
        }
    },

    //FRINGE BENEFITS
    async getFringeBenefitHistory(userId) {
        try{            
            const response = await axios.get(`Benefits/fringe/history/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api getFringeBenefitHistory error')
            throw error
        }
    },
    async addFringeBenefits(data) {
        try{            
            const response = await axios.post(`Benefits/fringe/add`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api addFringeBenefits error')
            throw error
        }
    },
    async updateFringeBenefits(data) {
        try{            
            const response = await axios.post(`Benefits/fringe/update`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api updateFringeBenefits error')
            throw error
        }
    },
    async deleteFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/delete/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api deleteFringeBenefits error')
            throw error
        }
    },
    async undoDeleteFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/undo_delete/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('Benefits api undoDeleteFringeBenefits error')
            throw error
        }
    },
    async rejectDeleteFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/reject_delete/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('Benefits api rejectDeleteFringeBenefits error')
            throw error
        }
    },
    async approveDeleteFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/approve_delete/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Benefits api approveDeleteFringeBenefits error')
            throw error
        }
    },
    async forReviewFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/forReview/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api forReviewFringeBenefits error')
            throw error
        }
    },
    async approveFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/approve/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api approveFringeBenefits error')
            throw error
        }
    },
    async rejectFringeBenefits(fringeBenefitsId) {
        try{            
            const response = await axios.post(`Benefits/fringe/reject/${fringeBenefitsId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Benefits api rejectFringeBenefits error')
            throw error
        }
    },
}